<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="crt1"><span class="small">THE ENTITY</span>. Copyright © 2004 by Eric Frattini. English translation copyright © 2008 by Dick Cluster. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="crt1"><a class="pubhlink" href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="crt1">Library of Congress Cataloging-in-Publication Data</p>
<p class="crt">Frattini, Eric.<br/>      The entity: five centuries of secret Vatican espionage / Eric Alonso Frattini; Translated by Dick<br/>Cluster.<br/>          p. cm.<br/>      ISBN-13: 978-0-312-37594-2<br/>      ISBN-10: 0-312-37594-8</p>
<p class="crt">   1. Espionage—Vatican City—History. 2. Intelligence service—Vatican City—History. I. Title.<br/>      UB271.V38F73 2008<br/>      327.12456’34—dc22</p>
<p class="right">2008025769</p>
<p class="crt1">First published in Spain by Espasa Calpe under the title <em>La Santa Alianza</em></p>
<p class="crt1">First U.S. Edition: November 2008</p>
<p class="crt1">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312375942_epub_cop_r1.vue?93662f74